var map = {
	"./bird.svg": 7191,
	"./engines/match/test/answer-1.svg": 5088,
	"./engines/match/test/answer-10.svg": 2185,
	"./engines/match/test/answer-2.svg": 2006,
	"./engines/match/test/answer-3.svg": 4036,
	"./engines/match/test/answer-4.svg": 4915,
	"./engines/match/test/answer-5.svg": 7077,
	"./engines/match/test/answer-6.svg": 2709,
	"./engines/match/test/answer-7.svg": 8836,
	"./engines/match/test/answer-8.svg": 8757,
	"./engines/match/test/answer-9.svg": 4357,
	"./farmer-high-five.png": 4367,
	"./farmer-pocket-hands.png": 3155,
	"./farmer.png": 500,
	"./icons/icon-arrow-down.svg": 2337,
	"./icons/icon-arrow-up.svg": 169,
	"./icons/icon-checkmark.svg": 4288,
	"./icons/icon-checkmark2.svg": 2734,
	"./icons/icon-close.svg": 84,
	"./icons/icon-cookie.svg": 4857,
	"./icons/icon-drag.svg": 6123,
	"./icons/icon-error.svg": 67,
	"./icons/icon-exit-fullscreen.svg": 1708,
	"./icons/icon-loading.svg": 2854,
	"./icons/icon-open-fullscreen.svg": 7978,
	"./icons/icon-plus.svg": 4634,
	"./icons/icon-pow.svg": 5267,
	"./icons/icon-sound-off.svg": 1824,
	"./icons/icon-sound-on.svg": 4197,
	"./icons/icon-task-menu.svg": 2039,
	"./next-button.svg": 6980,
	"./parallax/background.png": 5385,
	"./parallax/foreground.png": 8557,
	"./parallax/middleground.png": 3623,
	"./parallax/tree.png": 9553,
	"./pig-tail.svg": 876,
	"./speech-bubble-instructions.svg": 4253,
	"./speech-bubble-welcome.svg": 8281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;